import { render, staticRenderFns } from "./location-search.vue?vue&type=template&id=23106a42&"
import script from "./location-search.vue?vue&type=script&lang=js&"
export * from "./location-search.vue?vue&type=script&lang=js&"
import style0 from "./_location-search.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports